import * as React from 'react';

function SubscriptionFailure() {
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card">
            <div className="card-body text-center">
              <div className="mb-4">
                <i className="mdi mdi-close-circle text-danger" style={{ fontSize: '48px' }}></i>
              </div>
              <h3 className="card-title text-danger">Subscription Payment Failed</h3>
              <p className="card-text">
                We were unable to process your subscription payment. This could be due to:
              </p>
              <ul className="list-unstyled">
                <li>Insufficient funds</li>
                <li>Expired card</li>
                <li>Invalid card details</li>
                <li>Bank declined the transaction</li>
              </ul>
              <div className="mt-4">
                <a href="/pricing" className="btn btn-primary me-3">
                  Try Again
                </a>
                <a href="mailto:support@decodeinvesting.com" className="btn btn-outline-secondary">
                  Contact Support
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionFailure;
